<template lang="html">
  <v-layout column>
    <v-card>
        <v-master-detail-pane :master-width="isMultiselectModeEnabled ? 6 : 3">
          <template slot="master">
            <v-load-nav-list title="Invoices"
                             searchPrompt="Search Invoice Transactions"
                             :loading="loadingTransactions"
                             :accurateSince="accurateSince"
                             :loads="invoices"
                             :customerLoads="invoicesGroupedByCustomer"
                             :groupedItems="selectedGroupedItems"
                             :company="company"
                             :custom-group-icon="isMultiselectModeEnabled ? 'receipt' : 'linear_scale'"
                             @update:searchTerm="search = $event"
                             @refresh="loadCompanyTransactions(company.id)">

              <template slot="toolbarItems" v-if="isXeroConnected(company)">
                <v-xero-billing-btn  v-if="isXeroConnected(company) && isMultiselectModeEnabled"
                                     :disabled="false"
                                     :loading="loadingBtn"
                                     :invoicing-company="company"
                                     :selections="multiSelections"
                                     @invoice-created="multiSelections = []"
                                     :multi-select-mode="isMultiselectModeEnabled"
                />
                <v-btn v-if="isMultiselectModeEnabled" :disabled="!multiSelections || multiSelections.length === 0"
                       @click="multiSelections = []">
                  <v-icon pr-1>clear</v-icon>
                  Clear
                </v-btn>
                <v-btn-toggle v-model="multiselectMode" class="mr-3">
                  <v-btn @click="multiSelections = isMultiselectModeEnabled ? [] : null">
                    <v-icon>checklist</v-icon>
                  </v-btn>
                </v-btn-toggle>
              </template>

              <template slot="loadTile"
                        slot-scope="{ idx, load: txn }">

                <v-list-tile :key="`load_txn_${idx}_${txn.id}`"

                             :class="{'primary lighten-1': isSelectedLoad(txn)}"
                             :inactive="isSelectedLoad(txn)"
                             ripple avatar>

                  <v-list-tile-action v-if="isMultiselectModeEnabled">
                    <v-checkbox v-model="multiSelections" :value="txn"/>
                  </v-list-tile-action>
                  <v-list-tile-content @click="selectLoad(txn)">
                    <v-list-tile-title>
                      {{ loadGroupSponsorName(txn.load.tacticalInfo.loadGroup) }}
                    </v-list-tile-title>
                    <v-list-tile-sub-title class="text--primary"
                                           v-if="bookedLoadNickname(txn.load)">
                      {{ bookedLoadNickname(txn.load) }}
                    </v-list-tile-sub-title>
                    <v-list-tile-sub-title class="text--primary">
                      <span v-if="txn.load.pickup">
                        {{ txn.load.pickup.when | formatTxDate}}
                      </span>
                      <span v-else-if="txn.load.tacticalInfo.scheduledPickupTime">
                        {{ txn.load.tacticalInfo.scheduledPickupTime | formatTxDate}}
                      </span>
                    </v-list-tile-sub-title>
                    <v-list-tile-sub-title>
                      {{ txn.loadHumanId }}: ${{ txn.amount }} ({{ txn.status || '[status]' }})
                    </v-list-tile-sub-title>
                  </v-list-tile-content>
                  <v-list-tile-action>
                    <v-chip :color="invoiceStatusIcon(txn).color"
                            text-color="white" small>
                      <v-icon>
                        {{ invoiceStatusIcon(txn).icon }}
                      </v-icon>
                    </v-chip>
                  </v-list-tile-action>
                </v-list-tile>
                <v-divider :key="`load_txn_divider_${idx}_${txn.id}`"/>
              </template>

              <template slot="groupedItemsTile" slot-scope="skope">
                <v-list-group :key="`invoiceGroupedBy_${skope.idx}`">
                  <v-list-tile slot="activator">
                    <template  v-if="isMultiselectModeEnabled">
                      <v-list-tile-action>
                        {{skope.items[0].customer.companyName}} ({{skope.item}} {{skope.items.length}} loads)
                      </v-list-tile-action>
                    </template>
                    <template v-else>
                      <v-list-tile-action>
                        <v-chip :color="invoiceStatusIcon({load: {loadStatus: skope.item} }).color"
                                text-color="white" small>
                          <v-icon>
                            {{ invoiceStatusIcon({load: {loadStatus: skope.item } }).icon }}
                          </v-icon>
                        </v-chip>
                      </v-list-tile-action>
                      <v-list-tile-title>
                        {{skope.item}}
                      </v-list-tile-title>
                    </template>
                  </v-list-tile>

                  <template v-for="txn in skope.items" >
                    <v-list-tile :key="`grouped_load_${txn.loadId}`"
                                 :class="{'primary lighten-1': isSelectedLoad(txn)}"
                                 :inactive="isSelectedLoad(txn)"
                                 ripple avatar>
                      <v-list-tile-action v-if="isMultiselectModeEnabled">
                        <v-checkbox v-model="multiSelections" :value="txn.loadId"/>
                      </v-list-tile-action>
                      <v-list-tile-content @click="selectLoad(txn)">
                        <v-list-tile-title>
                        {{ loadGroupSponsorName(txn.load.tacticalInfo.loadGroup) }}
                        </v-list-tile-title>
                        <v-list-tile-sub-title class="text--primary"
                                               v-if="bookedLoadNickname(txn.load)">
                          {{ bookedLoadNickname(txn.load) }}
                        </v-list-tile-sub-title>
                        <v-list-tile-sub-title class="text--primary">
                          <span v-if="txn.load.pickup">
                            {{ txn.load.pickup.when | formatTxDate}}
                          </span>
                          <span v-else-if="txn.load.tacticalInfo.scheduledPickupTime">
                            {{ txn.load.tacticalInfo.scheduledPickupTime | formatTxDate}}
                          </span>
                        </v-list-tile-sub-title>
                        <v-list-tile-sub-title>
                          {{ txn.loadHumanId }}: ${{ txn.amount }}
                        </v-list-tile-sub-title>
                      </v-list-tile-content>
                    </v-list-tile>
                    <v-divider :key="`load_divider_${txn.loadId}`"/>
                  </template>
                </v-list-group>
              </template>

              <template slot="customerLoadsTile" slot-scope="skope">
                <v-list-group :key="`customerLoad_${skope.idx}`">
                  <v-list-tile slot="activator">
                    <v-list-tile-action>
                      <v-chip color="primary"
                              text-color="white" small>
                        {{ skope.loads.length }}
                      </v-chip>
                    </v-list-tile-action>
                    <v-list-tile-title>
                      {{skope.sponsor}}
                    </v-list-tile-title>
                  </v-list-tile>
                  <template v-for="txn in skope.loads" >
                    <v-list-tile :key="`grouped_load_${txn.loadId}`"
                                 :class="{'primary lighten-1': isSelectedLoad(txn)}"
                                 :inactive="isSelectedLoad(txn)"
                                 ripple avatar>
                      <v-list-tile-action v-if="isMultiselectModeEnabled">
                        <v-checkbox v-model="multiSelections" :value="txn.loadId"/>
                      </v-list-tile-action>
                      <v-list-tile-content @click="selectLoad(txn)">
                        <v-list-tile-title class="text--primary"
                                           v-if="bookedLoadNickname(txn.load)">
                          {{ bookedLoadNickname(txn.load) }}
                        </v-list-tile-title>
                        <v-list-tile-sub-title>
                         {{ _.get(txn, 'load.loadStatus', '') }}
                        </v-list-tile-sub-title>
                        <v-list-tile-sub-title class="text--primary">
                          <span v-if="txn.load.pickup">
                            {{ txn.load.pickup.when | formatTxDate}}
                          </span>
                            <span v-else-if="txn.load.tacticalInfo.scheduledPickupTime">
                          {{ txn.load.tacticalInfo.scheduledPickupTime }}
                          </span>
                        </v-list-tile-sub-title>
                        <v-list-tile-sub-title>
                          {{ txn.loadHumanId }}: ${{ txn.amount }}
                        </v-list-tile-sub-title>
                      </v-list-tile-content>
                    </v-list-tile>
                    <v-divider :key="`load_divider_${txn.loadId}`"/>
                  </template>
                </v-list-group>
              </template>
            </v-load-nav-list>
          </template>

          <template slot="detail">
            <v-load-transaction-details v-if="selected"
                                        :transaction="selected"
                                        invoice
                                        :company="company"
                                        @reset-selected="selectLoad(null)"
                                        @reload="onRefresh()"
                                        :banner-title="`${selected.loadHumanId}`"
                                        :multi-transaction-export="isMultiselectModeEnabled"
                                        :loading="loadingTransactions">
              <template slot="toolbarButtons">
                <!-- nothing to go here really -->
              </template>

            </v-load-transaction-details>
          </template>
        </v-master-detail-pane>
    </v-card>
  </v-layout>
</template>

<script>
import _ from 'lodash';
import * as Timestamps from '@/types/timestamp';

import bookedLoadMixin from '@/mixins/bookedLoadMixin';
import filterLoadsMixin from '@/mixins/filterLoads';
import loadGroupMixin from '@/mixins/loadGroupMixin';
import loadTransactionsMixin from '@/mixins/loadTransactionsMixin';

import VMasterDetailPane from '@/components/MasterDetailPane';
import VLoadNavList from '@/components/dashboard/simple/LoadNavList';
import VLoadTransactionDetails from '@/components/dashboard/simple/LoadTransactionDetails';

import { loadStatus } from '@/types';
import xeroMixin from '../../../mixins/xeroMixin';
import VXeroBillingBtn from '../../../components/xero/XeroBillingButton.vue';

export default {
  name: 'Invoices',
  mixins: [
    bookedLoadMixin,
    filterLoadsMixin,
    loadGroupMixin,
    loadTransactionsMixin,
    xeroMixin,
  ],
  components: {
    VXeroBillingBtn,
    VLoadNavList,
    VLoadTransactionDetails,
    VMasterDetailPane,
  },
  props: {
    txId: {
      type: String,
      required: false,
    },
    company: {
      type: Object,
    },
  },
  filters: {
    formatTxDate(dateString) {
      return dateString ? Timestamps.formattedDate(dateString) : '';
    },
  },
  watch: {
    selected() {
      if (_.get(this.selected, 'id', false)) {
        this.$router.push({ params: { txId: this.selected.id } });
      }
    },
    loadingTransactions() {
      if (this.$route.params.txId) {
        this.selected = _.find(this.invoiceTransactions, { id: this.$route.params.txId });
      }
    },
    multiSelections(val) {
      console.log('MultiSelections', val);
    },
    multiselectMode(val) {
      if (val === 0) {
        this.multiSelections = [];
      }
    }
  },
  computed: {
    _() {
      return _;
    },
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    bills() {
      return _.filter(this.billTransactions, tx => this.filterLoadTransaction(tx));
    },
    invoices() {
      return _.filter(this.invoiceTransactions, tx => this.filterLoadTransaction(tx));
    },
    invoicesGroupedByCustomer() {
      const nameSorted = _.sortBy(this.invoices, tx => _.get(tx, 'customer.companyName', ''));
      return _.groupBy(nameSorted, tx => _.get(tx, 'customer.companyName', ''));
    },
    selectedGroupedItems() {
      return this.isMultiselectModeEnabled ? this.invoicesGroupedByLoadGroup : this.invoicesGroupedByStatus;
    },
    invoicesGroupedByStatus() {
      const nameSorted = _.sortBy(this.invoices, tx => _.get(tx, 'customer.companyName', ''));
      return _.groupBy(nameSorted, tx => _.get(tx, 'load.loadStatus', ''));
    },
    invoicesGroupedByLoadGroup() {
      const loadGroupSorted = _.sortBy(this.invoices, tx => _.get(tx, 'customer.companyName', ''));
      const groups = _.groupBy(loadGroupSorted, tx => _.get(tx, 'load.tacticalInfo.loadGroup.humanId'));
      console.log("GROUPS", groups);
      return groups;
    },
    accurateSince() {
      if (this.loadingTransactions) {
        return 'Loading ...';
      }

      if (this.transactionsTime) {
        return `Updated ${this.$options.filters.formatTimeStamp(this.transactionsTime)}`;
      }

      return 'Refresh';
    },
    isMultiselectModeEnabled() {
      // since it is a toggle button, the value is 0 when enabled. undefined or null means disabled.
      return this.multiselectMode === 0;
    },

    hasTransactionsPermissions() {
      // pass through to the mixin probably
      return true;
    },
  },
  beforeRouteUpdate(to, from, next) {
    if (to.params.txId !== from.params.txId && to.params.txId !== _.get(this.selected, 'id', null)) {
      this.selected = _.find(this.invoiceTransactions, { id: to.params.txId });
    }

    next();
  },
  methods: {
    selectLoad(txn) {
      if (this.isMobile && txn) {
        this.$router.push({ name: 'transaction.detail',
          params: { id: txn.id } });
      } else {
        this.selected = txn;
      }
    },
    isSelectedLoad(txn) {
      return txn.id === _.get(this.selected, 'id', null);
    },
    bookedLoadIcon(txn) {
      return this.bookedLoadProgressIcon(txn.load);
    },
    invoiceStatusIcon(txn) {
      // let's help identify the actionable transactions
      const loadIcon = this.bookedLoadIcon(txn);
      if (txn.load.loadStatus === loadStatus.DELIVERED) {
        loadIcon.color = 'green';
      }
      return loadIcon;
    },
    logClick(skope) {
      console.log('Skope', skope);
    }
  },
  data: () => ({
    selected: null,
    multiselectMode: null,
    multiSelections: null,
    loadingBtn: false,
  }),
  beforeDestroy() {
    const storageKey = `${this.company.id}_tr_invoice`;
    if (_.get(this.selected, 'id', false)) {
      localStorage.setItem(storageKey, this.selected.id);
    } else {
      localStorage.removeItem(storageKey);
    }
  },
  created() {
    const storageItem = localStorage.getItem(`${this.company.id}_tr_invoice`);
    if (storageItem) {
      this.selected = _.find(this.invoiceTransactions, { id: storageItem });
    }
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/pages/Companies/Transactions/Invoices.vue